import { deleteCookie } from "utils/cookieManagement";

// Google-specific identity keys. These must be dropped on logout AND when a
// different account signs in (e.g. email/password), otherwise a leftover
// google_data/auth_type pair resurrects the previous Google profile on the
// next page load (see hooks/useAuthInitialization).
const GOOGLE_IDENTITY_KEYS = ["google_data", "user_nickname", "user_email"];

// Everything that represents an authenticated session in localStorage.
const SESSION_KEYS = [
  "api_key",
  "user_id",
  "auth_type",
  "user_data",
  ...GOOGLE_IDENTITY_KEYS,
];

const SESSION_COOKIES = ["ses_userdata", "ses_sid", "ses_name", "ses_token"];

/**
 * Remove the residual Google identity so it can't be re-read on boot. Use when
 * a non-Google login succeeds while stale Google keys may still be present.
 */
export const clearGoogleIdentity = (): void => {
  GOOGLE_IDENTITY_KEYS.forEach((key) => localStorage.removeItem(key));
};

/**
 * Fully clear the persisted auth session (localStorage keys + legacy session
 * cookies). Callers typically follow this with a full-page reload so Redux
 * re-initializes from the now-empty storage.
 */
export const clearAuthSession = (): void => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  SESSION_COOKIES.forEach(deleteCookie);
};
